// extracted by mini-css-extract-plugin
export var section = "index-module--section--1eXc6";
export var sectionBackground = "index-module--sectionBackground--1jPMI";
export var logoImg = "index-module--logoImg---4v6W";
export var infoContainer = "index-module--infoContainer--1wsG6";
export var mainTitle = "index-module--mainTitle--1rRqt";
export var secondariTitle = "index-module--secondariTitle--_2q6R";
export var secondariTitle__rignt = "index-module--secondariTitle__rignt----_Ph";
export var buttonContainer = "index-module--buttonContainer--2LiHl";
export var button = "index-module--button--nxgVz";